import { Component, Input, Output, EventEmitter } from '@angular/core';
import { OlapService } from 'app/service/olap-service.service';

@Component({
    selector: 'app-loading-button',
    templateUrl: 'app-loading-button.component.html'
})

export class AppLoadingButtonComponent {
    @Input() label: string;
    @Output() action = new EventEmitter();

    constructor(private OlapService: OlapService) {}

    performAction() {
        this.OlapService.isLoading = true;
        this.action.emit();
    }
}



// WEBPACK FOOTER //
// /opt/sss_web/sss_web/src/app/components/app-loading-button/app-loading-button.component.ts